// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import i18next from "i18next";
import * as Setting from "../Setting";

export default function SiteFooter() {
  const domain = Setting.getEcpServerUrl() || "https://payments.angelalign.com";

  return (
    <footer className="site-legal-footer">
      <span>ANGELALIGN TECHNOLOGY PTE. LTD. All rights reserved.</span>
      <span className="site-legal-footer-sep">|</span>
      <a
        target="_blank"
        href={`${domain}/ecp/static/privacyNoticeSwiss.html`}
        rel="noreferrer"
      >
        {i18next.t("modification:Privacy Policy")}
      </a>
      <span className="site-legal-footer-sep">|</span>
      <a
        target="_blank"
        href={`${domain}/ecp/static/termsOfUseGeneral.html`}
        rel="noreferrer"
      >
        {i18next.t("modification:Footer Terms of Use")}
      </a>
    </footer>
  );
}
